import React, { useEffect } from 'react';
import './newworkordermodal.css';
import NewWorkOrder from './newworkorder';

const NewWorkOrderModal = ({ showModal, toggleModal, onWorkOrderCreated, initialData = null }) => {
  // Add/remove class to App when modal opens/closes
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('newworkorder-open');
    } else {
      appElement?.classList.remove('newworkorder-open');
    }
    
    // Cleanup on unmount
    return () => {
      appElement?.classList.remove('newworkorder-open');
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  return (
    <div className="newworkordermodal-overlay">
      <div className="newworkordermodal-content">
        <NewWorkOrder 
          onWorkOrderCreated={onWorkOrderCreated} 
          onClose={toggleModal}
          initialData={initialData}
        />
      </div>
    </div>
  );
};

export default NewWorkOrderModal;
